import _get from 'lodash/get';

import { STEP_NUMBER_MAP } from '../stubs';

export default function getTrackingUpdateStep(updates) {
  const status = _get(updates, 'status', '');
  return _get(STEP_NUMBER_MAP, status, -1);
}
